import { CloudDownload, Print } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import React from "react";

interface PackageItemProps {
  item: { type: "digital" } | { type: "print"; quantity: number; size: string };
  index?: number;
}

const PackageItem: React.FC<PackageItemProps> = ({ item, index = 0 }) => {
  return (
    <Box
      key={index}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 1.5,
        borderRadius: 1,
        backgroundColor: "background.default",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {item.type === "digital" ? (
        <>
          <CloudDownload
            sx={{ color: "primary.main", fontSize: 24 }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Digital Download
            </Typography>
            <Typography variant="caption" color="text.secondary">
              High-resolution digital file
            </Typography>
          </Box>
          <Chip
            label="Digital"
            size="small"
            color="primary"
            variant="outlined"
          />
        </>
      ) : (
        <>
          <Print sx={{ color: "secondary.main", fontSize: 24 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Size: {item.size}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Quantity: {item.quantity}
            </Typography>
          </Box>
          <Chip
            label="Print"
            size="small"
            color="secondary"
            variant="outlined"
          />
        </>
      )}
    </Box>
  );
};

export default PackageItem;
